import React, { useState, useContext, useEffect,useRef } from 'react';
import { PageContext } from './PageContext';
import { OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import { StatusList } from './FormComponents';
import { ZIndexContext} from '@progress/kendo-react-common';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { MMJobJacket } from './MMJobJacket';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import {faInfoCircle,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import parse from 'html-react-parser';
import { getMMToningBundle, releaseGetNext, updateAdStatus } from '../services/apiService';
import { RunDates } from './RunDates';
import { MMFileList } from './MMFileList';
import { MMHistoryList } from './MMHistoryList';
import { JobTicket } from './JobTicket';
import { Proof } from './Proof';
import { getProofFiles, approveAd, addWatchList } from '../services/apiService';
import { AdToApprove } from "../services/interfaces";
import {ApproveConfirmDialog, ConfirmDialog} from './ConfirmDialog';
import { SubmissionForm } from './SubmissionForm';
import { SubmissionContextProvider } from './SubmissionFormContext';

import {
    Toolbar,
    ToolbarItem,
    ToolbarSeparator,
    Button,
    ButtonGroup,
    DropDownButton,
    DropDownButtonItem,
    SplitButton,
    SplitButtonItem
} from '@progress/kendo-react-buttons';

import { adRecord,mmJob } from '../services/interfaces';
import { StatusDataItem } from '../services/interfaces';
import { useSearchParams } from 'react-router-dom';
export function MMExpand(){
    const pageContext = useContext(PageContext);
    const [adStatus, setAdStatus]=useState<StatusDataItem>();
    const [selectedTab, setSelectedTab] = useState<number>(1);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);
    const [expandConfirmTitle, setExpandConfirmTitle] = useState("");
    const [expandConfirmVisible, setExpandConfirmVisible] = useState(false);
    const [expandConfirmMessage, setExpandConfirmMessage] = useState("");
    const [expandConfirmConfirm, setExpandConfirmConfirm] = useState(() => () => {});
    const [expandConfirmCancel, setExpandConfirmCancel] = useState<() => void>(() => {});
    const [approveConfirmVisible, setApproveConfirmVisible]=useState(false);
    const [statChangeConfirmVisible, setStatChangeConfirmVisible]=useState(false);
    const [successMsg,setSuccessMsg]=useState("");
    const [showSuccess, setShowSuccess]=useState(false);
    const [errorMsg,setErrorMsg]=useState("");
    const [showError, setShowError]=useState(false);
    const [submitVisible, setSubmitVisible]=useState(false);
    const [submitTitle, setSubmitTitle]=useState("Submit");
    const [submitType,setSubmitType] =useState("SB");
    const selectedJob = useRef<mmJob>({
        mmJobName: "",
        requestedBy: "",
        turnaroundTime: "",
        files: 0,
        color: "",
        cob: "",
        croppingInfo: "",
        needsCropping: "",
        resolution: "",
        status: "",
        specialInstructions: "",
        submitter: "",
        archived: 0,
        site: "",
        size: "",
        tonedBundle: "",
        jobDescription: "",
        jobType: "",
        returnType: "",
        format: "",
        customer: "",
        received: "",
        beginProcess: "",
        endProcess: "",
        assigned: "",
        openArtTime: "",
        closeArtTime: "",
        tempChar4: "",
    });
    const showSetStatusConfirm=()=>{
        setStatChangeConfirmVisible(true);
    }
    const hideSetStatusConfirm=()=>{
        setStatChangeConfirmVisible(false);
    }

    const notifySuccess=()=>{
        setShowSuccess(true);
    }
    const hideNotifySuccess=()=>{
        setShowSuccess(false);
    }

    const notifyError=()=>{
        setShowSuccess(true);
    }
    const hideNotifyError=()=>{
        setShowSuccess(false);
    }

    const hideSubmit=()=>{
        setSubmitVisible(false);
    }

    const showSubmit=()=>{
        if (pageContext?.selectedAd.tmpInt2==0){
            setSubmitType("SB");
            setSubmitTitle("Submit materials for ad " + pageContext?.selectedAd.slug);
        }else{
            setSubmitType("CR");
            setSubmitTitle("Submit corrections for ad " + pageContext?.selectedAd.slug);
        }
        setSubmitVisible(true);
    }

    const showPickup=()=>{
        setSubmitType("PU");
        setSubmitTitle("Pickup " + pageContext?.selectedAd.slug + " To:");
        setSubmitVisible(true);
    }

    const [SearchParams] = useSearchParams();
    const act = SearchParams.get('act');


    function newStatusConfirm(stat:any){
        console.log(stat);
        setAdStatus(stat);
        showSetStatusConfirm();
    }

    function setNewStatus(){
        const stat = adStatus?.status||"";
        if (pageContext && pageContext.selectedAd.element!="" && stat!=""){
            updateAdStatus(pageContext.selectedAd.element, stat);
        }else{
            console.log("Status not set");
        }
        hideSetStatusConfirm();
    };

    const addWatch=()=>{
        const element = pageContext?.selectedAd.element;
        addWatchList(element).then(resp=>{
            if (resp!="Error"){
                setSuccessMsg(element + " has been added to your watch list.")
                notifySuccess();
                setTimeout(function () { hideNotifySuccess() }, 5000);
            }else{
                setErrorMsg("An error occurred." + element + " has not been added to your watch list.")
                notifyError();
                setTimeout(function () { hideNotifyError() }, 5000);
            }
        });
    }

    const removeWatch=()=>{

    }

    const openPDF =()=>{
        var d = new Date();
        var tick = d.getTime();
        var pdfPath = pageContext?.proofFiles.pdfURL + "&t=" + tick;
        var newtab = window.open(pdfPath);
        if (newtab && pageContext?.selectedAd.element) {
            newtab.document.title = pageContext.selectedAd.element;
        }
    }
    const isHold=()=>{
        if (pageContext){
            const adStatus = pageContext.selectedAd.status;
            const holdStatuses = pageContext.atolStatuses.HoldStatuses;
            if (holdStatuses.indexOf(adStatus)!=-1){
                return true;
            }else{
                return false;
            }        
        }
    }

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelectedTab(e.selected);
    };

    function copyClipboard(){
        navigator.clipboard.writeText(pageContext?.selectedAd.mmJobName||"Not Found");
    }
    const showApproveConfirm=()=>{
        setApproveConfirmVisible(true);
    }
    const hideApproveConfirm=()=>{
        setApproveConfirmVisible(false);
    }
    const ConfirmApprove=()=>{        
        console.log("Approve clicked");
        showApproveConfirm();
    }
    const ApproveAd=(rating:{
        accuracy:number,
        creativity:number,
        timliness:number
    })=>{
        hideApproveConfirm();
        console.log("Approve confirmed");
        console.log(rating);
        const adToApprove:AdToApprove={
            element: pageContext?.selectedAd.element || "",
            adType:pageContext?.selectedAd.elementType||"",
            setStatus:"",
            approvalEmail:"",
            account:pageContext?.selectedAd.fileSize2||"",
            salesRep:pageContext?.selectedAd.salesman||"",
            rating:""
        }
        console.log(adToApprove);
    }

    const closeExpand=()=>{
        const element = pageContext?.page.fromGetNext||"";
        if (element!=""){
            releaseGetNext(element);
        }
        toggleExpand();
    }

    function checkAction(){
        if (act){
            switch (act){
                case "A":
                    ConfirmApprove();
                    break;
                case "C":
                    showSubmit();
                    break;
                case "S":
                    showSubmit();
                    break;
            }
        }
    }
    function downloadBundle(){
        console.log("Download bundle");
        console.log(selectedJob.current);
        var jobPath = selectedJob.current.tonedBundle;
        console.log(jobPath);
        if (jobPath!=null && jobPath!==""){
            var fixPath=jobPath.replace("\\\\","/").replace(/\\/g,"/");
            console.log(fixPath);
            getMMToningBundle(fixPath).then(data=>{
                console.log(data);
                if (data!=="" && data!=="error"){
                    setSuccessMsg("Download of "+selectedJob.current.mmJobName+ " starting");
                    setShowSuccess(true);
                    setTimeout(function () { setShowSuccess(false); }, 10000);
                    window.open(data);
                }else{
                    setErrorMsg("Files for "+selectedJob.current.mmJobName+ " are not available at this time.");
                    setShowError(true);
                    setTimeout(function () { setShowError(false); }, 10000);
                }
            });
        }
    }


    useEffect(() => {
        //console.log(pageContext?.selectedAd);
        Object.assign(selectedJob.current,pageContext?.selectedAd);
        console.log(selectedJob.current);
        //if ((pageContext?.selectedAd.tmpInt2 ?? 0) > 0){
        setSelectedTab(0);
        //}
        //getProofFiles(pageContext?.selectedAd.element, pageContext?.selectedAd.slug, pageContext?.selectedAd.tmpInt2,"","1",pageContext?.selectedAd.file1).then(data=>{
        //    console.log(data);
        //    pageContext?.setProofFiles(data);
        //});
        //checkAction();
    }, []);

    return(
        <>
        <OffcanvasHeader toggle={closeExpand}>
            Job Jacket - {selectedJob.current.mmJobName} <a href="#" onClick={copyClipboard}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
        </OffcanvasHeader>
        <OffcanvasBody className='h-100'>
            <ZIndexContext.Provider value={1060}>
                {showSuccess&& <Notification type={{style:"success", icon:true}}><span>{successMsg}</span></Notification>}
                {showError&& <Notification type={{style:"error", icon:true}}><span>{errorMsg}</span></Notification>}
                {selectedJob.current.tonedBundle?
                <Toolbar>
                    <Button onClick={downloadBundle}>Download</Button>
                </Toolbar>
                :null                
                }
                <TabStrip selected={selectedTab} onSelect={handleSelect}>
                    <TabStripTab title="Job Jacket" contentClassName='expand-panel'>
                        <MMJobJacket {...selectedJob.current}></MMJobJacket>
                    </TabStripTab>
                    <TabStripTab title="Files" contentClassName='expand-panel'>                        
                        <div className='expand-panel-content'>
                            <MMFileList {...selectedJob.current}></MMFileList>
                        </div>
                    </TabStripTab>
                    <TabStripTab title="History" contentClassName='expand-panel'>
                        <div className='expand-panel-content'>
                            <MMHistoryList {...selectedJob.current}></MMHistoryList>
                        </div>
                    </TabStripTab>
                </TabStrip>
            </ZIndexContext.Provider>
        </OffcanvasBody>
        </>
    )
}
